import BradySdk from '@bradycorporation/brady-web-sdk';

const printerUpdateCB = () => {
    console.log('Printer data changed.');
}

export default class printer {
    bradySdk = new BradySdk(printerUpdateCB);

    constructor() {
        this.bradySdk.setCutOption(2); // 0: EndOfJob Cut, 1: EndOfLabel Cut, 2: No Cut
    }

    getStatus = () => {
        return this.bradySdk.status;
    }

    getPrinterData = () => {
        var printerData = {};
        printerData.name = this.bradySdk.printerName;
        printerData.model = this.bradySdk.printerModel;
        printerData.batteryLevelPercentage = this.bradySdk.batteryLevelPercentage;
        printerData.acCharging = this.bradySdk.isAcConnected;
        printerData.supplyName = this.bradySdk.supplyName;
        printerData.supplyRemainingPercentage = this.bradySdk.supplyRemainingPercentage;
        return printerData;
    }

    setCutOption = (cutOption) => 
    {
        this.bradySdk.setCutOption(cutOption);
    }

    isConnected = () => {
        return this.bradySdk.printerDiscovery.bleApi.isConnected
            && this.bradySdk.printerDiscovery.bleApi.bluetoothGatt.connected;
    }

    isSupportedBrowser = () => {
        return this.bradySdk.isSupportedBrowser();
    }

    connect = async () => {
        try {
            var success = await this.bradySdk.showDiscoveredBleDevices();
            success ? console.log('Connect succeeded.') : console.log('Connect failed.');
            return success;
        }
        catch (error) {
            console.log('Connect failed.');
            console.log(error);
            return false;
        }
    }

    disconnect = async () => {
        try {
            var success = await this.bradySdk.disconnect();
            success ? console.log('Disconnect succeeded.') : console.log('Disconnect failed. This may be because no printer was connected to begin with.');
            return success;
        }
        catch (error) {
            console.log('Disconnect failed.');
            console.log(error);
            return false;
        }
    }

    cut = async () => {
        try {
            var success = await this.bradySdk.cut();
            success ? console.log('Cut succeeded.') : console.log('Cut failed.');
            return success;
        }
        catch (error) {
            console.log('Cut failed.');
            console.log(error);
            return false;
        }
    }

    feed = async () => {
        try {
            var success = await this.bradySdk.feed();
            success ? console.log('Feed succeeded.') : console.log('Feed failed.');
            return success;
        }
        catch (error) {
            console.log('Feed failed.');
            console.log(error);
            return false;
        }
    }

    getPrintOffsets = (supplyName) => {
        switch (supplyName) {
            // Update this offset when we get a new supply to test with.
            case 'M4-7-422':
                return { horizontalOffset: 0.0, verticalOffset: 0.0 };
            case 'M21-7-423':
                return { horizontalOffset: 0.0, verticalOffset: -0.09 };
            case 'M21-500-423':
                return { horizontalOffset: 0.0, verticalOffset: .1 };
            default:
                return { horizontalOffset: 0, verticalOffset: 0 };
        }
    }

    print = async (image) => {
        var img = new Image();
        img.src = URL.createObjectURL(image);

        // These offsets are specific to printing on M4-7-422 labels on the M511 printer.
        // These offsets do not affect labels of equivalent size to the printer.
        // It may be necessary to make this more robust in the future if other labels/printers are desired.
        this.bradySdk.verticalOffset = .05;
        this.bradySdk.leftOffset = 0;
        
        let offsets = this.getPrintOffsets(this.bradySdk.supplyName);

        img.onload = async () => {
            try {
                var success = await this.bradySdk.printBitmap(img, offsets.horizontalOffset, offsets.verticalOffset);
                success ? console.log('Print succeeded.') : console.log('Print failed.');
                URL.revokeObjectURL(img.src);
                return success;
            }
            catch (error) {
                console.log('Print failed.');
                console.log(error);
                URL.revokeObjectURL(img.src);
                return false;
            }
        }
    }
}